import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, role } = useSelector((store) => store.auth);
  const location = useLocation();

  // Check authentication first
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (!allowedRoles.includes(role)) {
    console.error("Unauthorized Access Attempt", {
      currentRole: role,
      allowedRoles,
    });

    // Redirect to an unauthorized page or back to login
    return (
      <Navigate
        to="/unauthorized"
        state={{
          message: `Access denied. Required roles: ${allowedRoles.join(", ")}`,
        }}
        replace
      />
    );
  }

  // If authenticated and role is allowed, render children
  return children;
};

// Main Private Routes Wrapper
export const PrivateRoutes = () => {
  const { isAuthenticated } = useSelector((store) => store.auth);
  const location = useLocation();

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;

